import { render } from "./serveur.vue?vue&type=template&id=4c6fff07&scoped=true"
import script from "./serveur.vue?vue&type=script&lang=js"
export * from "./serveur.vue?vue&type=script&lang=js"

import "./serveur.vue?vue&type=style&index=0&id=4c6fff07&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6fff07"]])

export default __exports__